/**
 * The hue an avatar falls on for a given seed.
 *
 * Extracted from `Avatar.vue` (#413): `people-ui/src/utils/avatar.ts` carried a
 * byte-for-byte copy of the same hash over the same palette, so the two could
 * drift into giving one person two different colours in two parts of the suite —
 * which reads as two different people.
 *
 * The hues live in `tokens/colors.css` (`--avatar-hue-1..8`, the categorical set) and are referenced
 * as CSS vars rather than hex, so the palette stays SSOT and a consumer never
 * hardcodes a colour (check:ds-no-raw-color).
 *
 * The hash itself is deliberately trivial and MUST NOT change: it is a stable
 * mapping from a person to a colour, and changing it recolours everybody at once.
 */
const AVATAR_HUES = [
  'var(--avatar-hue-1)',
  'var(--avatar-hue-2)',
  'var(--avatar-hue-3)',
  'var(--avatar-hue-4)',
  'var(--avatar-hue-5)',
  'var(--avatar-hue-6)',
  'var(--avatar-hue-7)',
  'var(--avatar-hue-8)',
];

export function avatarHue(seed: string | null | undefined): string {
  const value = String(seed ?? '');
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  return AVATAR_HUES[hash % AVATAR_HUES.length];
}
